{
  "keystone": "Keystone",
  "common": {
    "open-in-browser": "Open in browser",
    "save": "Save",
    "cancel": "Cancel",
    "no-data": "No data",
    "go-back": "Back"
  },
  "teams": {
    "welcome": "Welcome, {{name}}!",
    "select-a-team-to-start-collaborating": "Select a team to start collaborating",
    "create-new-team": "Create new team",
    "create-team-subtitle": "Start setting up your workspace",
    "create-new-project": "Create new project",
    "team-dashboard-coming-soon": "Team dashboard coming soon.",
    "projects": "Projects",
    "loading-projects": "Loading projects...",
    "no-projects-found": "No projects found for this team.",
    "show-more": "Show more...",
    "project-count-one": "{{count}} project",
    "project-count-other": "{{count}} projects"
  },
  "recent-projects": {
    "header": "Home",
    "title": "Recent projects",
    "loading": "Loading recent projects...",
    "no-recent-projects": "No recent projects. Select a project from a team to see it here.",
    "embedded": {
      "you-have-no-recent-projects": "You have no recent projects.",
      "please-select-a-team": "Please select a team in the menu and check your available projects."
    },
    "getting-started": "Getting started",
    "tasks-assigned-to-me": "Tasks assigned to me",
    "your-teams": "Your teams"
  },
  "getting-started": {
    "early-access-title": "You're using an early access version",
    "early-access-description": "You're among the first to try Open Collaboration Platform. This early access version has a limited feature set and some parts of the product may change or be unstable. If you have issues or ideas, let us know through our help center.",
    "open-help-center": "Open help center",
    "setup-workspace-title": "Set up your workspace",
    "setup-step-1": "Select your team and open an existing project or create a new one.",
    "setup-step-2": "Download the OCP Connection add-on for your authoring tool and upload your first model to OCP.",
    "setup-step-3": "Optionally, upload IFC files directly from your browser on the Models page.",
    "setup-step-4": "Invite your team members to your project on Members page.",
    "setup-step-5": "Review models and create tasks in the 3D viewer, either in your browser or from your authoring tool.",
    "need-help": "Need help?",
    "visit-help-guide": "Visit our help guide"
  },
  "form": {
    "errors": {
      "required": "This field is required",
      "minlength": "Minimum {{minLength}} characters required",
      "invalid-emails": "Please enter valid email addresses"
    }
  },
  "login-form": {
    "welcome-to-ocp": "Welcome to Open Collaboration Platform!",
    "connect-tools-data-and-people-to-collaborate-seamlessly": "Connect tools, data, and people to collaborate seamlessly across projects.",
    "sign-in": "Sign in",
    "create-account": "Create account"
  },
  "create-account-form": {
    "title": "Create account",
    "description": "To join OCP, sign in with an Allplan ID or Graphisoft ID.",
    "continue-with-allplan-id": "Continue with Allplan ID",
    "continue-with-graphisoft-id": "Continue with Graphisoft ID",
    "already-have-account": "Already have an account?",
    "sign-in": "Sign in."
  },
  "create-form": {
    "team": {
      "create-team": "Create Team",
      "team-name-placeholder": "Team name",
      "buttons": {
        "create-team": "Create Team",
        "cancel": "Cancel"
      }
    },
    "project": {
      "create-project": "Create Project",
      "rename-project": "Rename project",
      "project-name-placeholder": "Project name",
      "buttons": {
        "create-project": "Create Project",
        "rename-project": "Rename",
        "cancel": "Cancel"
      },
      "error": {
        "a-project-with-this-name-already-exists-choose-a-different-name": "A project with this name already exists. Choose a different name.",
        "an-unexpected-error-occurred-please-try-again": "An unexpected error occurred. Please try again."
      }
    }
  },
  "update-model-card": {
    "update-model": "Update model",
    "show-more": "Show more",
    "show-less": "Show less",
    "view": "View",
    "update": "Update",
    "version": "Version"
  },
  "update-model-dialog": {
    "add-details": "Add details",
    "summarize-what-changed": "Summarize what changed.",
    "description": "Description",
    "next": "Next",
    "cancel": "Cancel",
    "confirm-model-update": "Confirm model update",
    "project": "Project",
    "model-name": "Model name",
    "confirm-and-update": "Confirm & Update"
  },
  "upload-form": {
    "add-details": "Add details",
    "choose-a-name-for-this-model-in-your-project": "Choose a name for this model in your project.",
    "model-name": "Model name",
    "description": "Description",
    "next": "Next",
    "cancel": "Cancel",
    "waiting-for-host": "Waiting for response from hosting application",
    "waiting-for-host-detail": "The application is waiting for a response from the hosting application.",
    "custom-selection": "Custom selection"
  },
  "upload-confirm": {
    "confirm-model-upload": "Confirm model upload",
    "project": "Project",
    "selected-model": "Selected model",
    "model-name": "Model name",
    "confirm-and-upload": "Confirm & Upload",
    "cancel": "Cancel"
  },
  "create-task-form": {
    "create-task": "Create task",
    "title": "Title",
    "title-placeholder": "Enter task title",
    "description": "Description",
    "description-placeholder": "Enter task description",
    "scene": "Scene",
    "add-scene-in-model": "Add scene in model",
    "remove-scene": "Remove scene",
    "assignee": "Assignees",
    "select-assignee": "Select assignees",
    "priority": "Priority",
    "select-priority": "Select",
    "status": "Status",
    "select-status": "Select",
    "due-date": "Due date",
    "select-date": "Select date",
    "tags-label": "Tags",
    "add-tags": "Add tags",
    "cancel": "Cancel",
    "submit": "Create task",
    "more-details": "More details",
    "less-details": "Less details",
    "watchers": "Watchers",
    "select-watchers": "Select watchers"
  },
  "bcf-export-form": {
    "export-bcf": "Export BCF",
    "select-format": "Select format:",
    "export-bcf-btn": "Export BCF",
    "cancel": "Cancel"
  },
  "create-organization-dialog": {
    "create-organization": "Create organization",
    "setup-the-workspace-where-your-team-can-host-projects": "Setup the workspace where your team can host projects and collaborate.",
    "for-this-you-can-create-an-ocp-organization-from": "For this you can create an OCP organization from your <b>existing Allplan or Graphisoft company accounts - where you are the company admin.</b>",
    "select-a-brand-where-you-have-your-organization": "Select a brand where you have your organization and you have your licenses:",
    "allplan-id-company": "Allplan ID company",
    "company-accounts-linked-to-your-allplan-id": "Company accounts linked to your Allplan ID",
    "graphisoft-id-company": "Graphisoft ID company",
    "company-accounts-linked-to-your-graphisoft-id": "Company accounts linked to your Graphisoft ID",
    "next": "Next",
    "close": "Close"
  },
  "create-organization-no-permission-dialog": {
    "create-organization": "Create organization",
    "you-dont-have-permission": "You don't have permission to create an organization.",
    "only-company-admins-can-create": "Only company admins can create an OCP organization. Please ask your company admin to create one for you.",
    "back": "Back",
    "close": "Close"
  },
  "breadcrumb": {
    "home": "Home",
    "teams": "Teams",
    "projects": "Projects",
    "models": "Models",
    "tasks": "Tasks",
    "overview": "Overview",
    "members": "Members",
    "current-page": "Current page",
    "create-new-team": "Create new team",
    "create-new-project": "Create new project",
    "open-menu-for": "Open menu for {{label}}"
  },
  "projects": {
    "settings": {
      "menu": "Project settings",
      "open-menu": "Open project settings",
      "rename-project-failed": "Project rename failed",
      "thumbnail-upload-success": "Project thumbnail updated",
      "thumbnail-upload-failed": "Project thumbnail update failed",
      "thumbnail-delete-success": "Project thumbnail deleted",
      "thumbnail-delete-failed": "Project thumbnail deletion failed",
      "actions": {
        "rename-project": "Rename project",
        "change-thumbnail-image": "Change thumbnail image",
        "delete-thumbnail-image": "Delete thumbnail image"
      }
    },
    "team": "Team",
    "models-count": "Models: {{count}}",
    "models-button": "Models",
    "add-new": "Add new",
    "issues": "Issues",
    "models-section": {
      "title": "Models",
      "view-all": "View all",
      "upload": "Upload"
    },
    "viewer-section": {
      "open-viewer": "Open 3D viewer",
      "illustration-alt": "3D model viewer illustration"
    },
    "tasks-section": {
      "title": "Tasks",
      "view-all": "View all",
      "create-new": "Create new",
      "no-tasks": "You have no tasks yet",
      "assigned-to-me": "Assigned to me",
      "open": "Open",
      "resolved": "Resolved",
      "closed": "Closed"
    }
  },
  "models": {
    "title": "Models",
    "upload": "Upload",
    "view": "View",
    "open-viewer": "Open 3D viewer",
    "upload-model": "Upload model",
    "view-selected": "View selected ({{quantity}})",
    "add-model-options": {
      "model": "Upload from Archicad via add-on",
      "model-description": "Download the add-on and upload directly from Archicad.",
      "ifc": "Upload IFC file",
      "ifc-description": "Upload an IFC model from your computer."
    },
    "add-model-dialog": {
      "title": "Add Model",
      "file-name": "File Name",
      "model-name": "Model Name",
      "add": "ADD",
      "cancel": "CANCEL",
      "close": "Close"
    },
    "upload-dialog": {
      "title": "Model Uploading",
      "model-name": "Model Name:",
      "status": "Status:",
      "status-creating": "Creating model...",
      "status-uploading": "Uploading...",
      "status-success": "Upload complete!",
      "status-error": "Upload failed",
      "file-read-error": "Failed to read file",
      "close": "CLOSE"
    },
    "rename-dialog": {
      "title": "Rename",
      "model-name": "Model Name",
      "rename": "Rename",
      "cancel": "Cancel"
    },
    "model-link-has-been-copied-to-clipboard": "Model link has been copied to clipboard.",
    "link-copy-failed": "Copy failed",
    "clipboard-permission-denied": "Clipboard access was denied.",
    "view-model": "View model",
    "delete": "Delete",
    "download": "Download",
    "rename": "Rename",
    "copy-link": "Copy link",
    "link-copied": "Link copied!",
    "no-models-found": "No models found for this project.",
    "search": "Search models",
    "filter": "Filter models",
    "filter-title": "Filters",
    "clear-all": "Clear all",
    "filter-show-all": "Show all",
    "filter-version": "Version",
    "filter-uploaded-by": "Uploaded by",
    "filter-modified-by": "Modified by",
    "filter-unassigned": "Unassigned",
    "filter-search-people": "Search people...",
    "filter-bar-expand": "Show search and filters",
    "filter-bar-collapse": "Hide search and filters",
    "filter-remove": "Remove filter",
    "filter-apply": "Apply",
    "filter-select": "Select",
    "filter-close": "Close filters",
    "filter-back": "Back",
    "filter-n-selected": "{{count}} selected",
    "drop-zone": {
      "title": "Drag and drop models to upload",
      "description": "IFC and IFCZIP formats are supported"
    },
    "columns": {
      "name": "Name",
      "version": "Version",
      "uploaded-by": "Uploaded by",
      "last-modified": "Last modified",
      "latest-contributor": "Latest contributor",
      "date-created": "Date created",
      "view": "View",
      "progress": "Progress",
      "actions": "Actions"
    },
    "errors": {
      "model-is-created-but-id-is-missing": "Model created but ID is missing"
    },
    "unsupported-file-type-dialog": {
      "error-title": "Error: Unsupported file type",
      "message": "The selected file type is not supported.\nPlease select an IFC or IFCZIP file.",
      "ok": "OK"
    },
    "embedded": {
      "quick-actions": "Quick actions",
      "upload-model": "Upload model",
      "upload-model-description": "Upload model directly from your app to the cloud.",
      "upload": "Upload",
      "upload-new-model": "Upload new model",
      "upload-status": "Upload status",
      "no-current-uploads": "No current uploads.",
      "waiting-for-response-from-hosting-application": "Waiting for response from Hosting application",
      "cancel-upload": "Cancel",
      "view-model": "View model",
      "copy-link": "Copy link",
      "your-upload-was-cancelled": "Your upload was cancelled."
    }
  },
  "nav-tabs": {
    "home": "Home",
    "overview": "Overview",
    "models": "Models",
    "tasks": "Tasks",
    "members": "Members"
  },
  "expired-dialog": {
    "your-session-expired": "Your session expired",
    "sign-in": "Sign in",
    "please-sign-in-again-to-continue-using-the-app": "Please sign in again to continue using the app."
  },
  "auth": {
    "sign-out": "Sign out",
    "help-center": "Help center",
    "authorization": "Authorization",
    "please-wait-while-we-validate-your-token": "Please wait while we validate your token.",
    "authorization-failed": "Authorization failed",
    "token-validation-failed": "Token validation failed. Please try logging in again.",
    "authorization-successful": "Authorization successful",
    "authorization-pending": "Authorization pending",
    "authorization-pending-please-wait": "Your request is being processed. This may take a moment.",
    "token-validated-successfully": "Token validated successfully.",
    "unauthorized": "Unauthorized",
    "session-expired-please-log-in-again": "Your session has expired. Please log in again."
  },
  "theme": {
    "dark-mode": "Dark mode",
    "light-mode": "Light mode",
    "system-mode": "System",
    "select-theme": "Select theme",
    "change-color-scheme": "Change color scheme",
    "theme": "Theme"
  },
  "language-switcher": {
    "change-language": "Change language",
    "select-language": "Select language",
    "language": "Language"
  },
  "sidebar": {
    "open-collaboration-platform": "Open Collaboration Platform",
    "early-access": "Early access",
    "early-access-program-agreement": "Early Access Program Agreement",
    "imprint": "Imprint"
  },
  "project-card": {
    "models": "models",
    "tasks": "tasks"
  },
  "context-nav": {
    "teams": "Teams",
    "organizations": "Organizations",
    "select-team": "Select a team",
    "projects": "Projects",
    "create-new-project": "Create new project",
    "create-new-team": "Create new team"
  },
  "members-list": {
    "title": "Members",
    "invite": "Invite",
    "search-placeholder": "Search members...",
    "loading": "Loading members...",
    "no-members-found": "No members found.",
    "member-options": "Member options",
    "columns": {
      "name": "Name",
      "role": "Role",
      "status": "Status",
      "actions": "Actions"
    },
    "owner": "owner",
    "status": {
      "active": "Active",
      "pending": "Pending"
    },
    "context-menu": {
      "remove-member": "Remove member",
      "revoke-invitation": "Revoke invitation",
      "resend-invite": "Resend invite"
    },
    "remove-dialog": {
      "remove-member": "Remove member",
      "are-you-sure-you-would-like-to-remove": "Are you sure you would like to remove {{memberName}} from the project {{projectName}}?",
      "cancel": "Cancel"
    },
    "revoke-dialog": {
      "revoke-invitation": "Revoke invitation",
      "are-you-sure-you-would-like-to-revoke-the-project": "Are you sure you would like to revoke the project invitation from: {{email}}?",
      "revoke": "Revoke",
      "cancel": "Cancel"
    }
  },
  "tasks-list": {
    "title": "Tasks",
    "create-new": "Create new",
    "import-bcf": "Import BCF",
    "import-bcf-in-progress": "Importing BCF file...",
    "import-bcf-success": "BCF file imported successfully.",
    "import-bcf-partial-success": "BCF file imported with some issues.",
    "import-bcf-failed": "Failed to import BCF file.",
    "import-bcf-invalid-file": "File type not allowed. Allowed: *.bcfzip, *.bcf",
    "header-options": "Header options",
    "filter": "Filter tasks",
    "filter-title": "Filters",
    "search": "Search tasks",
    "clear-all": "Clear all",
    "filter-show-all": "Show all",
    "filter-status": "Status",
    "filter-priority": "Priority",
    "filter-assignee": "Assignee",
    "filter-reported-by": "Reported by",
    "filter-unassigned": "Unassigned",
    "filter-search-people": "Search people...",
    "filter-bar-expand": "Show search and filters",
    "filter-bar-collapse": "Hide search and filters",
    "filter-remove": "Remove filter",
    "filter-n-selected": "{{count}} selected",
    "filter-apply": "Apply",
    "filter-select": "Select",
    "filter-close": "Close filters",
    "filter-back": "Back",
    "grid-view": "Grid view",
    "select-status": "Select status",
    "select-assignee": "Select assignees",
    "list-view": "List view",
    "assign-selected-to": "Assign selected to",
    "loading": "Loading tasks...",
    "no-tasks-found": "No tasks found.",
    "select-all": "Select all tasks",
    "select-task": "Select task",
    "task-options": "Task options",
    "modified-label": "Modified",
    "columns": {
      "id": "ID",
      "title": "Title",
      "priority": "Priority",
      "status": "Status",
      "due-date": "Due date",
      "assignee": "Assignees",
      "reported-by": "Reported by",
      "actions": "Actions"
    },
    "status": {
      "title": "Status",
      "set-status": "Set status",
      "open": "Open",
      "solved": "Solved",
      "closed": "Closed"
    },
    "priority": {
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "menu": {
      "view-details": "View details",
      "copy-link": "Copy link"
    },
    "aria": {
      "priority-for-task": "Priority for task #{{shortId}}: {{name}}",
      "status-for-task": "Status for task #{{shortId}}: {{name}}",
      "assignee-for-task": "Assignee for task #{{shortId}}: {{name}}"
    },
    "not-set": "Not set",
    "link-copied": "Link copied",
    "link-copied-detail": "Task link has been copied to clipboard.",
    "link-copy-failed": "Copy failed",
    "clipboard-not-available": "Clipboard is not available in this browser.",
    "clipboard-permission-denied": "Clipboard access was denied."
  },
  "task-detail": {
    "untitled-task": "Untitled task",
    "enter-title": "Enter task title",
    "enter-description": "Enter task description",
    "no-description": "No description added.",
    "task-title-updated": "Task title updated!",
    "task-description-updated": "Task description updated!",
    "scene-updated": "Scene updated successfully!",
    "scene-creation-failed": "Failed to create the scene or upload its thumbnail.",
    "invalid-thumbnail": "Invalid thumbnail image.",
    "invalid-thumbnail-url": "Failed to process the thumbnail URL.",
    "scene-update-failed": "Failed to update scene.",
    "scene-updated-partially": "Scene updated partially",
    "scene-updated-partially-detail": "Some changes could not be saved to this scene.",
    "scene-deleted": "Scene deleted successfully!",
    "scene-delete-failed": "Failed to delete scene.",
    "status-label": "Status",
    "priority-label": "Priority",
    "assignee-label": "Assignee",
    "assignees-label": "Assignees",
    "due-date-label": "Due date",
    "reported-by-label": "Reported by",
    "created-label": "Created",
    "modified-label": "Modified",
    "tags-label": "Tags",
    "tags-hint": "Separate multiple tags with semicolons (;).",
    "tags-remove": "Remove {{tag}}",
    "not-set": "Not set",
    "none": "None",
    "unassigned": "Unassigned",
    "watchers-label": "Watchers",
    "unknown": "Unknown",
    "type-name": "Type name...",
    "comments": "Comments",
    "tab-comments": "Comments",
    "scene": "Scene",
    "open-scene": "Open scene",
    "view-in-model": "View in model",
    "add-scene": "Add scene",
    "sort-newest-first": "Newest first",
    "sort-oldest-first": "Oldest first",
    "status": {
      "open": "Open",
      "solved": "Solved",
      "closed": "Closed"
    },
    "priority": {
      "not-set": "Not set",
      "low": "Low",
      "medium": "Medium",
      "high": "High"
    }
  },
  "priority-dropdown": {
    "not-set": "Not set",
    "low": "Low",
    "medium": "Medium",
    "high": "High"
  },
  "status-dropdown": {
    "set-status": "Set status",
    "not-set": "Not set",
    "open": "Open",
    "resolved": "Resolved",
    "closed": "Closed"
  },
  "assignee-dropdown": {
    "unassigned": "Unassigned",
    "type-name": "Type name..."
  },
  "member-badge-group": {
    "assignees-count": "{{count}} assignees",
    "watchers-count": "{{count}} watchers"
  },
  "due-date-picker": {
    "not-set": "Not set",
    "clear": "Clear"
  },
  "scene-thumbnail": {
    "no-scene": "No scene saved"
  },
  "scene-list": {
    "previous": "Previous scene",
    "next": "Next scene",
    "go-to-scene": "Go to scene",
    "scene-thumbnail-alt": "Scene thumbnail",
    "update-scene": "Update scene",
    "delete-scene": "Delete scene",
    "selected-objects": "{{count}} objects selected"
  },
  "pagination": {
    "navigation": "Page navigation",
    "previous": "Previous page",
    "next": "Next page",
    "go-to-page": "Go to page"
  },
  "invite-form": {
    "project": {
      "invite-members": "Invite members",
      "you-can-add-multiple-addresses-separate-them-with-a": "You can add multiple addresses — separate them with a comma, semicolon, or space.",
      "enter-email-addresses": "Enter email addresses",
      "buttons": {
        "invite-to-project": "Invite to project",
        "cancel": "Cancel"
      }
    }
  },
  "email-chips-input": {
    "remove-email": "Remove {{email}}"
  },
  "multiselect-row": {
    "selected": "selected",
    "export-bcf": "Export BCF"
  },
  "notification": {
    "invitation-sent": "Invitation sent!",
    "has-been-invited-to": "{{email}} has been invited to {{projectName}}.",
    "invitation-failed": "Invitation failed",
    "could-not-send-invitation-to": "Could not send invitation to {{email}}. Please try again.",
    "user-is-already-a-member": "User is already a member",
    "is-already-a-member-no-new-invitation-was-sent": "{{email}} is already a member. No new invitation was sent.",
    "invitation-revoked": "Invitation revoked",
    "the-invitation-to-has-been-revoked": "The invitation to {{email}} has been revoked. They cannot join this project.",
    "revoke-failed": "Revoke failed",
    "could-not-revoke-the-invitation-for": "Could not revoke the invitation for {{email}}. Please try again.",
    "invitation-resent": "Invitation resent",
    "the-invitation-email-has-been-resent-to": "The invitation email has been resent to {{email}}.",
    "resend-failed": "Resend failed",
    "could-not-resend-the-invitation-for": "Could not resend the invitation for {{email}}. Please try again.",
    "member-removed": "Member removed",
    "has-been-removed-from-the-project": "{{name}} has been removed from the project {{projectName}}.",
    "remove-failed": "Removal failed",
    "could-not-remove-from-the-project": "Could not remove {{name}} from the project. Please try again."
  },
  "comment-form": {
    "placeholder": "Add comment",
    "add-comment": "Add comment",
    "cancel": "Cancel"
  },
  "comment": {
    "close": "Close",
    "attachment-link": "Attachment link",
    "hyperlink": "Hyperlink"
  },
  "countries": {
    "AL": "Albania",
    "DZ": "Algeria",
    "AD": "Andorra",
    "AO": "Angola",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BH": "Bahrain",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BO": "Bolivia",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BR": "Brazil",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CO": "Colombia",
    "CG": "Congo-Brazzaville",
    "CR": "Costa Rica",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "CI": "Côte d’Ivoire",
    "DK": "Denmark",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "EE": "Estonia",
    "SZ": "Eswatini",
    "ET": "Ethiopia",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "GA": "Gabon",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GR": "Greece",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GN": "Guinea",
    "GY": "Guyana",
    "HN": "Honduras",
    "HK": "Hong Kong SAR of China",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "XK": "Kosovo",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MK": "Macedonia",
    "MG": "Madagascar",
    "MY": "Malaysia",
    "ML": "Mali",
    "MT": "Malta",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "MD": "Moldova",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NL": "Netherlands",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "KP": "North Korea",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PA": "Panama",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "KN": "Saint Kitts and Nevis",
    "SM": "San Marino",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "ZA": "South Africa",
    "KR": "South Korea",
    "ES": "Spain",
    "SR": "Suriname",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syria",
    "TW": "Taiwan",
    "TH": "Thailand",
    "BS": "The Bahamas",
    "TG": "Togo",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "YE": "Yemen",
    "ZW": "Zimbabwe"
  },
  "delete-form": {
    "model": {
      "delete-model": "Delete model",
      "are-you-sure-you-would-like-to-delete": "Are you sure you want to delete this model? <br>This action cannot be undone.",
      "delete": "Delete model",
      "cancel": "Cancel",
      "toastErrorTitle": "Couldn't delete model",
      "toastErrorDescription": "We couldn't delete this model. Please try again.",
      "toastInfoTitle": "Model deleted",
      "toastInfoDescription": "The model was deleted from your project."
    }
  }
}
